import audioBufferUtils from 'audio-buffer-utils';
import audioCtx from './context';
import { PauseStep } from './../pattern/step';
let audioBufferOriginal, audioBufferReverse;
const createBufferFromPattern = async (pattern, _audioBufferOriginal, durationPerBar, durationFaderClick = 0.045 // @TODO: scale with playbackRate?
) => {
    audioBufferOriginal = _audioBufferOriginal;
    _validatePattern(pattern);
    _createReverseBuffer(audioBufferOriginal);
    let bufferPromises = pattern.steps.map((step) => {
        if (step instanceof PauseStep) {
            return createPauseBuffer(step.length, durationPerBar);
        }
        else {
            return createBufferForStep(step, durationPerBar, durationFaderClick);
        }
    });
    let buffers = [];
    await Promise.all(bufferPromises)
        .then(_buffers => { buffers = _buffers; })
        .catch(reason => { console.error('ERROR', reason); });
    console.log('ALL audio buffers', buffers);
    return audioBufferUtils.concat(...buffers);
};
const createBufferForStep = async (step, durationPerBar, durationFaderClick) => {
    const isForward = step.yDimensions[0] < step.yDimensions[1];
    const _buf = isForward ? audioBufferOriginal : audioBufferReverse;
    // which part of the sample? (which segment, aka yDimension)
    let ySliceStart = step.startY;
    let ySliceEnd = step.endY;
    if (!isForward) {
        ySliceStart = 1 - ySliceStart;
        ySliceEnd = 1 - ySliceEnd;
    }
    const sliceStart = ySliceStart * _buf.length;
    const sliceEnd = ySliceEnd * _buf.length;
    let bufSliced = audioBufferUtils.slice(_buf, sliceStart, sliceEnd);
    if (step.startClosed) {
        const end = bufSliced.sampleRate * durationFaderClick / 2;
        audioBufferUtils.zero(bufSliced, null, 0, end);
    }
    if (step.endClosed) {
        const start = bufSliced.sampleRate * (bufSliced.duration - durationFaderClick / 2);
        audioBufferUtils.zero(bufSliced, null, start);
    }
    // Assuming 4/4 takt -> 1bar = 4 quarter notes/beats
    const durationPerStep = durationPerBar / 4;
    const stepLength = step.endX - step.startX;
    const stepDuration = stepLength * durationPerStep;
    const playbackRate = bufSliced.duration / stepDuration;
    return await _createNewBufferByRecording(bufSliced, playbackRate);
};
const createPauseBuffer = (stepLength, durationPerBar) => {
    const durationPerBeat = durationPerBar / 4;
    const audioLength = audioBufferOriginal.sampleRate * stepLength * durationPerBeat; // @TODO: scale!
    let audioBufferPause;
    try {
        audioBufferPause = audioBufferUtils.create(audioLength, audioBufferOriginal.numberOfChannels, audioBufferOriginal.sampleRate);
    }
    catch (error) {
        console.error(error);
        audioBufferPause = audioBufferUtils.create(0, audioBufferOriginal.numberOfChannels, audioBufferOriginal.sampleRate);
    }
    return audioBufferPause;
};
const _createNewBufferByRecording = async (audioBuffer, playbackRate) => {
    if (audioBuffer.length <= 0) {
        return Promise.reject('Buffer has length of 0');
    }
    let length = audioBuffer.length / playbackRate;
    let offlineCtx = new OfflineAudioContext(audioBuffer.numberOfChannels, length, audioBuffer.sampleRate);
    let offlineSource = offlineCtx.createBufferSource();
    offlineSource.buffer = audioBuffer;
    offlineSource.playbackRate.value = playbackRate;
    offlineSource.connect(offlineCtx.destination);
    offlineSource.start(0);
    return await offlineCtx.startRendering(); // @TODO add try-catch
};
const _createReverseBuffer = (audioBufferOriginal) => {
    audioBufferReverse = audioBufferUtils.clone(audioBufferOriginal);
    audioBufferUtils.reverse(audioBufferReverse, audioBufferReverse);
};
const _validatePattern = (pattern) => {
    // @TODO: check no overlap in X
    // @TODO: validate x and y ranges
    return true;
};
const createBufferSource = (audioBuffer, gainNode) => {
    let bufferSource = audioCtx.createBufferSource();
    bufferSource.buffer = audioBuffer;
    bufferSource.loop = true;
    bufferSource.connect(gainNode);
    return bufferSource;
};
export default createBufferFromPattern;
export { createBufferFromPattern, createBufferSource, };
